import React from 'react';
import List from "@material-ui/core/List";
import {Chip, Container} from "@material-ui/core";
import {blueGrey} from "@material-ui/core/colors";
import ListItem from "@material-ui/core/ListItem";
import Accordion from '@material-ui/core/Accordion';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AlarmIcon from '@material-ui/icons/Alarm';
import {MateriasSource} from "../Source/MateriasSource";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import {UVT_MATERIAS, UVT_MATERIAS_BY_TOPIC_ID} from "../Source/Materias";
import VideoPlayer from "react-simple-video-player";
import Factory, {RESOURCES_BASEPATH} from "../Factory";

const useStyles = makeStyles((theme) => ({
    root: {
        color: blueGrey[800],
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: '500',
    },
    semestre: {
        padding: '25px 0'
    },
    section: {
        padding: '20px 0'
    },
    subSection: {
        padding: '20px 0'
    },
    accordionHeader: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '80%',
        flexShrink: 0,
    },
}));

export default function Contenido(props) {
    const classes = useStyles();

    function getDueDatesArray(section) {
        const sectionsWithDueDates = section.recursos.filter(o => o.dueDate);
        return sectionsWithDueDates.length ? sectionsWithDueDates.map(o => o.dueDate) : [];
    }

    return (
        <Container className={classes.root}>
            <div className={classes.titles}>
                <Typography variant="h2" gutterBottom>
                    {UVT_MATERIAS_BY_TOPIC_ID[`${props.match?.params?.id}`].name}
                </Typography>
                <div className={classes.section}>
                    <Typography variant="h3" gutterBottom>
                        Video de Bienvenida
                    </Typography>
                    <VideoPlayer
                        // width=
                        // aspectRatio='3:3'
                        url="https://uvt-public-assets.s3-us-west-1.amazonaws.com/VideoIntroAdmin.mp4"
                        poster={`${RESOURCES_BASEPATH}/LogoAdmin.jpeg`}
                    />
                </div>
                <div className={classes.section}>
                    <Typography variant="h3" gutterBottom>
                        Contenido Temático
                    </Typography>
                    {UVT_MATERIAS_BY_TOPIC_ID["FB-392104"].temas.map(o => {
                        return (
                            <div className={classes.section}>
                                <div className={classes.subSection}>
                                    <Typography variant="h6" gutterBottom>
                                        {o.descripcion}
                                    </Typography>
                                    <Typography>
                                        {o.objetivo}
                                    </Typography>
                                </div>
                                {o.subtemas.map(a => {
                                    return (
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon/>}
                                                aria-controls="panel1a-content"
                                                // id={o.topicId}
                                            >
                                                <Typography
                                                    className={classes.accordionHeader}>{a.subtema}
                                                </Typography>
                                                <Typography>
                                                    {getDueDatesArray(a).map(date => {
                                                        return (
                                                            <>
                                                                <Chip
                                                                    icon={<AlarmIcon/>}
                                                                    label={`Entrega: ${date}`}
                                                                    clickable
                                                                    color="secondary"
                                                                />
                                                            </>
                                                        );
                                                    })}
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Typography>
                                                    {a.recursos.map(b => {
                                                        return (
                                                            <Factory component={b}/>
                                                        );
                                                    })}
                                                </Typography>
                                            </AccordionDetails>
                                        </Accordion>
                                    );
                                })}
                            </div>
                        );
                    })}
                </div>
                <div className={classes.section}>
                    <Typography variant="h3">
                        Políticas de Evaluación
                    </Typography>
                    <Typography variant="body1">
                        {UVT_MATERIAS_BY_TOPIC_ID["FB-392104"].evaluacion.acreditacion}
                    </Typography>
                    <List>
                        {UVT_MATERIAS_BY_TOPIC_ID["FB-392104"].evaluacion.rubricas.map(o => {
                            return (
                                <ListItem>
                                    <ListItemText
                                        primary={o.rubrica}
                                        secondary={`Porcentaje de la Calificación: ${o.porcentajeString}`}
                                    />
                                </ListItem>
                            );
                        })}
                    </List>
                </div>
                <div className={classes.section}>
                    <Typography variant="h3">
                        Actividades a Evaluar
                    </Typography>
                    <List>
                        {UVT_MATERIAS_BY_TOPIC_ID["FB-392104"].evaluacion.procedimientos.map(o => {
                            return (
                                <ListItem>
                                    <ListItemText
                                        primary={o.procedimiento}
                                    />
                                </ListItem>
                            );
                        })}
                    </List>
                </div>
                <div className={classes.section}>
                    <Typography variant="h3">
                        Actividades a Realizar de Manera Independiente por el Alumno
                    </Typography>
                    <List>
                        {UVT_MATERIAS_BY_TOPIC_ID["FB-392104"].actividadesIndependientes.map(o => {
                            return (
                                <ListItem>
                                    <ListItemText
                                        primary={o.actividad}
                                    />
                                </ListItem>
                            );
                        })}
                    </List>
                </div>
                <div className={classes.section}>
                    <Typography variant="h3">
                        Actividades a Realizar de Manera Guiada con el Profesor
                    </Typography>
                    <List>
                        {UVT_MATERIAS_BY_TOPIC_ID["FB-392104"].actividadesConAcademico.map(o => {
                            return (
                                <ListItem>
                                    <ListItemText
                                        primary={o.actividad}
                                    />
                                </ListItem>
                            );
                        })}
                    </List>
                </div>
            </div>
        </Container>
    );
}

